<script setup lang="ts">
import BasicBlock from '@/components/shared/blocks/BasicBlock.vue';
import { IMeeting, ISuggestion } from '@/stores/meetings';
import i18n from '@/utils/i18n';
import SuggestionsOverlay from '@/views/meetings/SuggestionsOverlay.vue';
import { computed, ref } from 'vue';

const showSuggestionsOverlay = ref<boolean>(false);

interface Props {
  suggestions: ISuggestion[];
  meeting: IMeeting;
}

const props = withDefaults(defineProps<Props>(), {});

const title = computed(() => {
  return `${props.suggestions.length} ${i18n.global.t('meeting.suggestionItems').toLowerCase()}`;
});
</script>

<template>
  <div>
    <BasicBlock
      :icon="['fal', 'lightbulb']"
      canTriggerOverlay
      :text="title"
      @click="showSuggestionsOverlay = true"
    />

    <SuggestionsOverlay
      v-if="showSuggestionsOverlay"
      :meeting="props.meeting"
      :suggestions="suggestions"
      @close="showSuggestionsOverlay = false"
    />
  </div>
</template>
